import React from 'react';
import { BrandHeartIcon } from '../SvgIcons/BrandHeart';
import { Container, HeartWrapper, LeftHeart, RightHeart } from './JoiningHeartsAnimation.styles';

const JoiningHeartsAnimation = (): JSX.Element => {
  return (
    <Container>
      <HeartWrapper>
        <LeftHeart>
          <BrandHeartIcon width={36} height={29} />
        </LeftHeart>
      </HeartWrapper>
      <HeartWrapper>
        <RightHeart>
          <BrandHeartIcon width={36} height={29} />
        </RightHeart>
      </HeartWrapper>
    </Container>
  );
};

export default JoiningHeartsAnimation;
